import FilePickerPanelViewState from '../store/schema/FilePickerPanelViewState';
import { updateSupportedFilePickerActionsForProviderFiles } from './updateSupportedFilePickerActions';
import { action } from 'satcheljs/lib/legacy';
import { FileProviderViewState } from 'owa-fileprovider-store';
import FileProviderItemViewState from '../store/schema/FileProviderItemViewState';

export default action('updateFileProviderItemsSelection')(function updateFileProviderItemsSelection(
    items: FileProviderItemViewState[],
    maxAllowedLocalFileSize: number,
    selectedFileProvider: FileProviderViewState,
    viewState: FilePickerPanelViewState
) {
    items = items || [];
    viewState.filePickerViewState.selectedFileProviderItems = items;
    updateSupportedFilePickerActionsForProviderFiles(
        items,
        maxAllowedLocalFileSize,
        selectedFileProvider,
        viewState
    );
});
